module.exports = __webpack_public_path__ + "static/img/file_xml.ba3e5900.png";